import { REGISTER_USER } from "shared/api";
import { loginWithEmail } from "shared/firebase/auth";
import { Form, Icon, NOTICES, Page, SubmitButton, TextField, useNavigator } from "shared/react";
import { REGISTER_SCHEMA } from "shared/schema";
import { callAPI } from "../util/api.js";

export function RegisterPage(): React.ReactElement {
	const nav = useNavigator();
	return (
		<Page title="Create account">
			<header>
				<img src="/img/icon.svg" className="icon size-5x" alt="Trajectory" title="Trajectory" />
				<h1>Create account</h1>
			</header>
			<Form
				schema={REGISTER_SCHEMA}
				onSubmit={async data => {
					await callAPI(REGISTER_USER, data);
					await loginWithEmail(data);
					nav.redirect("/");
					NOTICES.success("Welcome to Trajectory!");
				}}
			>
				<TextField name="username" />
				<TextField name="email" autocomplete="username" />
				<TextField name="password" autocomplete="new-password" />
				<SubmitButton>Register</SubmitButton>
			</Form>
			<footer className="size-small flex-row gap-xsmall">
				<a href="/" className="button button-quiet">
					<Icon icon="left" /> <span>Login</span>
				</a>
			</footer>
		</Page>
	);
}
